import { Profile } from '$logic/profile/types'
import { createKeyvalStorage, createKeyvalView } from '../lib/keyval.storage'

const key = 'profile'

export const profileStorage = createKeyvalStorage<Profile>(key)

export const profileView = createKeyvalView<Profile>(key)
